import React from "react";
import { ExternalLink } from "lucide-react";
import "./News.css";

function HorizontalNews({ news }) {
  if (!news || news.length === 0) {
    return <div>No News Available</div>;
  }

  return (
    <div className="horizontal-news-container">
      {news.map((article, idx) => (
        <div key={idx} className="horizontal-news-card">
          {article.image && (
            <img
              src={article.image}
              alt={article.title}
              className="horizontal-news-img"
            />
          )}
          <div className="horizontal-news-info">
            <a
              href={article.url}
              target="_blank"
              rel="noopener noreferrer"
              className="horizontal-news-title"
            >
              {article.title} <ExternalLink size={12} />
            </a>
            <div className="horizontal-news-meta">
              <span>{article.site}</span>
              <span>{new Date(article.publishedDate).toLocaleDateString()}</span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default HorizontalNews;
